import { type ReactNode } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import {
  ensureRouteData,
  modelingCurvesQueryOptions,
  modelingStatusQueryOptions,
} from '~/lib/query';
import {
  segmentFieldsQueryOptions,
  segmentDraftQueryOptions,
} from '~/features/portfolio/use-segment';
import { modelingAssumptionsQueryOptions } from '~/features/modeling/use-modeling-assumptions';
import { ModelingPage } from '~/features/modeling/ModelingPageConnected';

export const Route = createFileRoute('/_protected/modeling')({
  loader: async ({ context }) => {
    // Page-defining data: await on the server (flash-free first paint), prefetch on the
    // client. The block-until-settled status is awaited so the first paint already knows
    // whether to show the "still processing" block or the analytics (no flash between them).
    // The curves read is warmed for the WHOLE portfolio (no segment arg) — cheap (it serves
    // from the precomputed D4 buckets) and ready the moment the dataset is fresh; the active
    // segment is a per-user client store that hydrates after paint, then the component
    // refetches the filtered slice. The segment fields + the user's draft warm the rail so
    // the SegmentPanel paints filled (shared with the Portfolio screen, so the cohort cannot
    // drift between the two). The per-user assumptions draft is warmed the same way, so the
    // Pricing/Cash-Flow panels' first paint reads the saved inputs (incl. the FTP curve).
    await Promise.all([
      ensureRouteData(context.queryClient, modelingStatusQueryOptions()),
      ensureRouteData(context.queryClient, modelingCurvesQueryOptions()),
      ensureRouteData(context.queryClient, segmentFieldsQueryOptions()),
      ensureRouteData(context.queryClient, segmentDraftQueryOptions()),
      ensureRouteData(context.queryClient, modelingAssumptionsQueryOptions()),
    ]);
  },
  component: ModelingRoute,
});

function ModelingRoute(): ReactNode {
  return <ModelingPage />;
}
